import {
  Button,
  Icon,
  IconButton,
  TooltipContent,
  TooltipRoot,
  TooltipTrigger,
} from '@socialchorus/shared-ui-components';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { uiOperations } from '../../../../models/ui';
import { ID as ARCHIVE_CONFIRM_DIALOG_ID } from '../../../v2/content-actions/archive-confirm-dialog';
import { FeedCardActionsProps } from './type';

export function FeedCardActionArchive({
  content,
  isHidden,
}: FeedCardActionsProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const label = t('content_submission.archive', 'Archive');

  const handleClick = () => {
    dispatch(
      uiOperations.displayOverlay(ARCHIVE_CONFIRM_DIALOG_ID, {
        contentId: content.id,
        reloadInPlace: true,
      })
    );
  };

  if (isHidden) {
    return (
      <Button
        variant="text"
        size="compact"
        label={label}
        leftIcon={<Icon>archive</Icon>}
        onClick={handleClick}
      />
    );
  }

  return (
    <TooltipRoot>
      <TooltipTrigger asChild>
        <IconButton
          aria-label={label}
          iconName="archive"
          size="compact"
          onClick={handleClick}
        />
      </TooltipTrigger>
      <TooltipContent description={label} />
    </TooltipRoot>
  );
}
